// frontend/src/components/mind-mesch/MindMeschLayout.js

import React from 'react';
import MindMeschNavbar from './MindMeschNavbar';
//import '../../styles/mind-mesch.css';

const MindMeschLayout = ({ children }) => {
  return (
    <div className="mindmesch-layout">
      <MindMeschNavbar />
      <main className="mindmesch-content">
        {children}
      </main>
    </div>
  );
};

export default MindMeschLayout;
